import React from 'react';
import {
	LegacyFormURLTextField,
	type LegacyFormURLTextFieldProps,
} from '@netx/core-components/URLTextField';

export interface CustomActionEndpointProps extends LegacyFormURLTextFieldProps {
	customActionId?: number;
}

export const CustomActionEndpointPrimitive = ({
	classes: _classes,
	className,
	customActionId,
	...props
}: CustomActionEndpointProps) => {
	return <LegacyFormURLTextField {...props} />;
};

export const CustomActionEndpoint = CustomActionEndpointPrimitive;

export default CustomActionEndpoint;
